import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';

import buttonTypes from './buttonTypes';
import './Button.scss';

const Button = (props) => {
  const {
    img,
    name,
    className,
    type,
    onClick,
    disabled,
    iconName
  } = props;

  const typeClass = (props.type ? `button__${type}` : null);

  let disable = false;
  if (disabled)
    disable = true;

  return (
    <button
      disabled={disable}
      className={classes('button', typeClass, className)}
      onClick={onClick}
    >
      {iconName ? <ion-icon name={iconName} /> : null}
      {img ? <img src={img} alt="template" /> : null}
      {name}
    </button>
  );
};

Button.propTypes = {
  img: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  iconName: PropTypes.string,
};

export {
  Button,
  buttonTypes
};



// WEBPACK FOOTER //
// ./src/app/components/Button/index.js